import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const Modal = styled.div`
  background-color: #fff;
  border-radius: 2px;
  min-width: 29rem;
  max-width: 80%;
  padding: 2rem 1.5rem 1.5rem 1.5rem;
  position: relative;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  max-height: 90vh;

   .square {
    width: 20rem;
    height: 32rem;
    position: relative; 
  }

  
  .square::before,
  .square::after {
    content: "";
    position: absolute;
    width: 50px;
    height: 50px;
    border: 2px solid #ccc;
  }

  .square::before {
    top: 0;
    left: 0;
    border-right: none;
    border-bottom: none;
  }

  .square::after {
    top: 0;
    right: 0;
    border-left: none;
    border-bottom: none;
  }

  .square .bottom-left,
  .square .bottom-right {
    position: absolute;
    width: 50px;
    height: 50px;
    border: 2px solid #ccc;
  }

  .square .bottom-left {
    bottom: 0;
    left: 0;
    border-right: none;
    border-top: none;
  }

  .square .bottom-right {
    bottom: 0;
    right: 0;
    border-left: none;
    border-top: none;
  }

  .camera-modal {
    display: flex;
    margin: auto;
    width: 50%;
    height: 100%;
    
    }

`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
`;



export const Title = styled.h2`
  width: 100%;
  margin: 0 0 2rem 0;
  font-size: 1.3rem;
  font-weight: 500;
`;

export const Buttons = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
  margin-top: 2rem;
`;

export const ModalButton = styled.button`
  padding: 0.7em 2em;
  
  border: none;
  font-size: 1em;
  cursor: pointer;
  background: var(--blue);
  color: #fff;
  &:last-child {
    background: #ffffffff;
    color: var(--blue);
    border: 1px solid var(--blue);
  }
`;